export const normalizeUrl = (value?: string | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (/^(https?:)?\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

/** Returns true when empty (optional) or a LinkedIn profile / short-link URL. */
export function isValidLinkedInProfileUrl(value?: string | null): boolean {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return true;

  try {
    const url = new URL(normalizeUrl(trimmed));
    const host = url.hostname.replace(/^www\./i, '').toLowerCase();
    if (host === 'lnkd.in') {
      return url.pathname.length > 1;
    }
    if (host !== 'linkedin.com') {
      return false;
    }
    const path = url.pathname.toLowerCase();
    return path.startsWith('/in/') || path.startsWith('/pub/') || path.startsWith('/company/');
  } catch {
    return false;
  }
}
